import { NavBar } from '../../../Modules/Navigation/components/NavBar/NavBar';
import Card from '../../../ui/Card/Card';
import styles from './TiktokAudios.module.css';
import { AudioPlayerProvider } from '../../../Modules/AudioPlayer/AudioPlayerContext';
import TiktokAudios from '../../../Modules/TikTok/audios/features/explore/TiktokAudioExplore/TiktokAudios';

const TiktokAudiosPage = () => {
    return (
        <AudioPlayerProvider>
            <div>
                <NavBar />
                <Card className={styles.content}>
                    <TiktokAudios />
                </Card>
            </div>
        </AudioPlayerProvider>
    );
};

export default TiktokAudiosPage;
